import { cssVariableStyles } from "@newsela/angelou";

const { generateIconColorCss } = cssVariableStyles;

export const iconCss = (color, isBookmarked) =>
  generateIconColorCss({
    primaryColor: isBookmarked ? color : "transparent",
    secondaryColor: color,
  });
